export default __webpack_public_path__ + "static/icon-female-c0ae516f4eb0f0088f4baebda5049751.png";